import React, { useEffect, useRef, useState } from "react";

// Scroll-triggered fade-up for public pages. Uses IntersectionObserver and
// CSS transitions (see .reveal in index.css), so there is no animation
// library cost. Reduced-motion users get the content immediately via CSS.
//
//   <Reveal>…</Reveal>                 single block
//   <Reveal delay={120}>…</Reveal>     manual stagger
//   <Reveal as="li" className="…">     custom element
function Reveal({ as: Tag = "div", delay = 0, className = "", children, ...rest }) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return;
        if (typeof IntersectionObserver === "undefined") {
            setVisible(true);
            return;
        }
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
        );
        observer.observe(node);
        return () => observer.disconnect();
    }, []);

    return (
        <Tag
            ref={ref}
            className={`reveal ${visible ? "is-visible" : ""} ${className}`}
            style={{ transitionDelay: `${delay}ms` }}
            {...rest}
        >
            {children}
        </Tag>
    );
}

export default Reveal;
